function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 455.731,
  height: 455.731,
  rx: 100,
  ry: 100,
  fill: "#40B0EF"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.7,0,0,0.7,68.35964813232422,68.35964813232422)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 455.731,
  height: 455.731,
  fill: "#40B0EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M358.844,100.6L54.091,219.359c-9.871,3.847-9.273,18.012,0.888,21.012l77.441,22.868l28.901,91.706   c3.019,9.579,15.158,12.483,22.185,5.308l40.039-40.882l78.56,57.665c9.614,7.057,23.306,1.814,25.747-9.859l52.031-248.76   C382.431,106.232,370.443,96.08,358.844,100.6z M320.636,155.806L179.08,280.984c-1.411,1.248-2.309,2.975-2.519,4.847   l-5.45,48.448c-0.178,1.58-2.389,1.789-2.861,0.271l-22.423-72.253c-1.027-3.308,0.312-6.892,3.255-8.717l167.163-103.676   C320.089,147.518,324.025,152.81,320.636,155.806z",
  fill: "#ffffff"
}));

function SvgTelegramShare({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 455.731 455.731",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiIHg9IjAiIHk9IjAiIHZpZXdCb3g9IjAgMCA0NTUuNzMxIDQ1NS43MzEiIHhtbDpzcGFjZT0icHJlc2VydmUiID4KICA8cmVjdCB3aWR0aD0iNDU1LjczMSIgaGVpZ2h0PSI0NTUuNzMxIiByeD0iMTAwIiByeT0iMTAwIiBmaWxsPSIjNDBCMEVGIi8+CiAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMC43LDAsMCwwLjcsNjguMzU5NjQ4MTMyMzI0MjIsNjguMzU5NjQ4MTMyMzI0MjIpIj4KCTxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSI0NTUuNzMxIiBoZWlnaHQ9IjQ1NS43MzEiIGZpbGw9IiM0MEIwRUYiLz4KICA8cGF0aAogICAgZD0iTTM1OC44NDQsMTAwLjZMNTQuMDkxLDIxOS4zNTljLTkuODcxLDMuODQ3LTkuMjczLDE4LjAxMiwwLjg4OCwyMS4wMTJsNzcuNDQxLDIyLjg2OGwyOC45MDEsOTEuNzA2ICAgYzMuMDE5LDkuNTc5LDE1LjE1OCwxMi40ODMsMjIuMTg1LDUuMzA4bDQwLjAzOS00MC44ODJsNzguNTYsNTcuNjY1YzkuNjE0LDcuMDU3LDIzLjMwNiwxLjgxNCwyNS43NDctOS44NTlsNTIuMDMxLTI0OC43NiAgIEMzODIuNDMxLDEwNi4yMzIsMzcwLjQ0Myw5Ni4wOCwzNTguODQ0LDEwMC42eiBNMzIwLjYzNiwxNTUuODA2TDE3OS4wOCwyODAuOTg0Yy0xLjQxMSwxLjI0OC0yLjMwOSwyLjk3NS0yLjUxOSw0Ljg0NyAgIGwtNS40NSw0OC40NDhjLTAuMTc4LDEuNTgtMi4zODksMS43ODktMi44NjEsMC4yNzFsLTIyLjQyMy03Mi4yNTNjLTEuMDI3LTMuMzA4LDAuMzEyLTYuODkyLDMuMjU1LTguNzE3bDE2Ny4xNjMtMTAzLjY3NiAgIEMzMjAuMDg5LDE0Ny41MTgsMzI0LjAyNSwxNTIuODEsMzIwLjYzNiwxNTUuODA2eiIKICAgIGZpbGw9IiNmZmZmZmYiLz4KPC9nPgo8L3N2Zz4K";
export { SvgTelegramShare as ReactComponent };